export default "__VITE_ASSET__e49b2ef3__"